import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AdminComponent} from './admin.component';
import {AuthGuard} from './auth-gaurd';
import {PieChartComponent} from './dashboard/graph/pie-chart/pie-chart.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', pathMatch: 'full', redirectTo: 'dashboard', canActivateChild: [true]},
      {path: 'dashboard', component: DashboardComponent},
      {path: 'profile', loadChildren: './profile/profile.module#ProfileModule'},
      {path: 'role', loadChildren: './role/role.module#RoleModule', canActivateChild: [AuthGuard]},
      {path: 'course', loadChildren: './course/course.module#CourseModule', canActivateChild: [AuthGuard]},
      {path: 'organisation', loadChildren: './organisation/organisation.module#OrganisationModule', canActivateChild: [AuthGuard] },
      {path: 'user', loadChildren: './user/user.module#UserModule', canActivateChild: [AuthGuard] },
      {path: 'section', loadChildren: './section/section.module#SectionModule', canActivateChild: [AuthGuard] },
      {path: 'topic', loadChildren: './topic/topic.module#TopicModule', canActivateChild: [AuthGuard] },
      {
        path: 'lrs',
        loadChildren: './organisation-lrs-configuration/organisation-lrs-configuration.module#OrganisationLrsConfigurationModule',
        canActivateChild: [AuthGuard],
      },
      {path: '**', redirectTo: './'}
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [AuthGuard],
  exports: [RouterModule]
})
export class AdminRoutingModule {
  /* routing module class */
}

/* List of components included in routes */
export const adminDeclaredComponentsList = [DashboardComponent, PieChartComponent];



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin.module.routing.ts